import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 104px 0;
`;

export const Heading = styled.div`
  font-weight: bold;
  font-size: 36px;
  line-height: 43px;
  text-align: center;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  overflow: hidden;
  margin: 0 44px;
  max-width: 350px;
  margin-bottom: 32px;
`;

export const CardImage = styled.img`
  width: 100%;
`;

export const CardImageContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CardButton = styled.button`
  background-color: white;
  color: #9b43ff;
  padding: 8px 24px;
  position: absolute;
  left: 16px;
  bottom: 16px;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  border: none;
  outline: none;
`;

export const CardTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 25px;
  height: 270px;
  @media (max-width: 600px) {
    height: 214px;
  }
`;

export const CardTitle = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const AvatarImage = styled.img`
  margin-right: 16px;
`;

export const UserName = styled.div`
  font-style: bold;
  font-size: 18px;
  line-height: 23px;
`;

export const UserTime = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: #878d96;
`;
